import styled from "styled-components"

export const TourDetailWrapper = styled.div`
    .sale{
        background-color: red;
        width: fit-content;
    }
    .btn-order{
        height: 50px;
    }
    .btn-add-favorite{
        height: 50px;
        width: 100%;
        cursor: pointer;
    }
    .box_img{
        position: sticky;
        top: 100px;
    }
    .img_empty{
        width: 100%;
        max-height: 450px;
        min-height: 450px;
        img{
            width: 100%;
            max-height: 450px;
            object-fit: cover;
        }
    }
    .description{
        img{
            max-width: 100%;
            object-fit: contain;
        }
    }
    .contact_info{
        a{
            display: block;
        }
    }
`